import { render, staticRenderFns } from "./VerificationsTable.vue?vue&type=template&id=f86f2240&"
import script from "./VerificationsTable.vue?vue&type=script&lang=js&"
export * from "./VerificationsTable.vue?vue&type=script&lang=js&"
import style0 from "./VerificationsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports